import {
    Home, StandardQuote, ViewQuote, ReviewQuote, ViewQuoteScreen, SyncData,
    UserManagement, InternalUserManagement, ReleaseNotes,
    Support, Overview, ContainerOrder, Settings
} from 'modules';
import { Routes, Route, Outlet } from "react-router";
import { Header } from 'components/header/Header';
import { Footer } from 'components/footer/footer';
import ChangePassword from 'modules/quote/change-password/ChangePassword';
import { Card, Container, Box } from '@mui/material';
import { PriceListCatalogue } from 'modules/quote/catelogue';
import { CompareTest } from 'modules/quote/catelogue/CompareTest';
import { ReleaseNotesHistory } from 'modules/admin/ReleaseNotesHistory';
import { OrderHistory } from 'modules/quote/module/BottleOrder/OrderHistory';
import BottleOrderPage from 'modules/quote/module/BottleOrder/BottleOrderPage';
import InventoryList from 'modules/quote/module/BottleOrder/Inventory/InventoryList';
import NewClientRequest from 'modules/quote/module/NewClientRequest/NewClientRequest';
import { ReviewConfirmation } from 'modules/quote/module/NewClientRequest/ReviewConfirmation';
import { Analytics } from 'modules/quote/module/Analytics/Analytics';
import { Dashboard } from 'modules/quote/Dashboard/Dashboard';
import PackageVersionDashboard from 'modules/moniter/PackageVersionDashboard';
import ManageProfile from 'modules/profiles/Manage_Profile/ManageProfile';
import { V2Quote } from 'modules/quote/Quote/V2Quote';

export const Layout = () => {
    function Screen() {
        return (
            <>
                <Header />
                <div className="content" style={{ backgroundColor: 'rgb(243, 243, 243)' }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            '& > :not(style)': {
                                m: 1,
                                width: "100%",
                                height: "auto",
                                maxWidth: "100%",
                                padding: '16px 16px'
                            }
                        }}
                    >
                        <Container maxWidth="xl" sx={{ marginBottom: 5, marginTop: 5, padding: 0 }}>
                            <Card variant="outlined" sx={{ padding: 3 }}>
                                <Outlet />
                            </Card>
                        </Container>
                    </Box>
                </div>
                <Footer />
            </>
        );
    }

    const jwt: any = localStorage.getItem('token');
    const labUserCheck: any = jwt ? JSON.parse(atob(jwt.split('.')[1])) : null;
    return (
        <Routes>
            <Route path="/" element={<Screen />}>
                <Route index element={labUserCheck?.UserType !== 'Internal' ? <Home /> : <ViewQuote />} />
                <Route path="monitor" element={<PackageVersionDashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="admin" element={<UserManagement />} />
                <Route path="generateQuote" element={<StandardQuote />} />
                <Route path="viewQuote" element={<ViewQuote />} />
                <Route path='reviewQuote' element={<ReviewQuote />} />
                <Route path='clientView' element={<ViewQuoteScreen />} />
                <Route path='syncData' element={<SyncData />} />
                <Route path='changePassword' element={<ChangePassword />} />
                <Route path='internal' element={<InternalUserManagement />} />
                <Route path='priceList' element={<PriceListCatalogue />} />
                <Route path='compareTest' element={<CompareTest />} />
                <Route path='releaseNotes' element={<ReleaseNotes />} />
                <Route path='releaseNotesHistory' element={<ReleaseNotesHistory />} />
                <Route path='support'>
                    <Route index element={<Support />} />
                    <Route path='overview' element={<Overview />} />
                    <Route path='container-ordering' element={<ContainerOrder />} />
                </Route>
                <Route path='orderHistory' element={<OrderHistory />} />
                <Route path='bottleOrderList' element={<BottleOrderPage />} />
                <Route path='settings' element={<Settings />} />
                <Route path='analytics' element={<Analytics />} />
                <Route path='new-client-request' element={<NewClientRequest />} />
                <Route path='review-client-request' element={<ReviewConfirmation />} />
                <Route path='inventory' element={<InventoryList />} />
                <Route path='manage-profiles' element={<ManageProfile />} />
                <Route path='v2-quote' element={<V2Quote />} />
            </Route>
        </Routes>
    )
}
